import { defineMessages } from 'react-intl'

export default defineMessages({
  patientName: {
    id: 'patientForm.patientName',
    defaultMessage: 'Patient name'
  },
  dateOfBirth: {
    id: 'patientForm.dateOfBirth',
    defaultMessage: 'Date of birth'
  },
  nationality: {
    id: 'patientForm.nationality',
    defaultMessage: 'Nationality'
  },
  sex: {
    id: 'patientForm.sex',
    defaultMessage: 'Sex'
  },
  address: {
    id: 'patientForm.address',
    defaultMessage: 'Address'
  },
  phoneNumber: {
    id: 'patientForm.phoneNumber',
    defaultMessage: 'Phone number'
  },
  turnOffCamera: {
    id: 'patientForm.turnOffCamera',
    defaultMessage: 'Turn off camera'
  },
  takePhotos: {
    id: 'patientForm.takePhotos',
    defaultMessage: 'Take photos'
  },
  toggleCamera: {
    id: 'patientForm.toggleCamera',
    defaultMessage: 'Toggle Camera'
  },
  close: {
    id: 'patientForm.close',
    defaultMessage: 'Close'
  },
  save: {
    id: 'patientForm.save',
    defaultMessage: 'Save'
  },
  patientUpdated: {
    id: 'patientForm.patientUpdated',
    defaultMessage: 'Patient updated.'
  },
  patientCreated: {
    id: 'patientForm.patientCreated',
    defaultMessage: 'Patient created.'
  }
})
